import { DateValue, getLocalTimeZone, toZoned } from '@internationalized/date';
import {
  enumUnit,
  Weight,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

const convertWeightToWeightInput = (weight: Weight | null): WeightInput => {
  if (!weight || !weight.value) {
    return {
      value: 0,
      unit: enumUnit.Pounds,
    };
  }
  return {
    value: weight.value,
    unit: weight.unit,
  };
};

export type BrokeredLoadMarkAsShippedParams = {
  loadId: string;
  shippedDate: DateValue;
  lightWeight: Weight | null;
  heavyWeight: Weight | null;
};

export const brokeredLoadMarkAsShippedAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadMarkAsShipped',
  (params: BrokeredLoadMarkAsShippedParams) => ({
    tradeLoadShip: {
      __args: {
        id: params.loadId,
        shippedDate: toZoned(
          params.shippedDate,
          getLocalTimeZone(),
        ).toAbsoluteString(),
        lightWeight: convertWeightToWeightInput(params.lightWeight),
        heavyWeight: convertWeightToWeightInput(params.heavyWeight),
      },
      id: true,
      status: true,
      shippedDate: true,
    },
  }),
);
